// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793116530858
      var cssReload = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  